export default __webpack_public_path__ + "static/media/house_of_dragon.424fb771.jpg";